<template>
    <div class="col-12 pt-4 px-0">
        <div class="ibox">
            <div class="ibox-title dashboard_title company-form-box-title pf-contribution">
                {{ page_title }}
            </div>
            <div class="ibox-content">


                <div class="col-12 mt-3">
                    <b-form-group id="approvers_depth-group" label="Approval Steps" label-for="approvers_depth">
                        <b-form-select id="approvers_depth" name="approvers_depth" v-model="approvers_depth" :options="approvers_depth_options" @input="updateApprovers"></b-form-select>
                    </b-form-group>
                </div>

                <div class="col-12 mt-3">
                    <div v-for="a in parseInt(approvers_depth)" :key="a" class="row approval-container">

                            <div class="col-4 approve-level-label">
                                <div class="approve-level-title">
                                    Level <span class="level-count">{{ approval_required_options[a].text }}</span>
                                </div>
                                <div class="approve-level-description">
                                    At each Level of Approval, multiple approvers can be assigned with a minimum number of affirmative approvals results required to deem the level to be Approved. Primary Approver(s) from the level's assigned approvers can also be defined in order to prioritize mandatory approver for the level.
                                </div>
                            </div>
                            <div class="col-8 approve-level-content">
                                <div class="approve-level-inside-container clearfix">
                                    <template v-for="(app,index) in global_approvers[a]">
                                        <b-form-checkbox class="" v-model="selected[a]" :value="app.value" :disabled="app.disabled" @change="findMe(app.value , a)">{{app.text}}</b-form-checkbox>
                                    </template>
                                </div>


                                <div class="approve-divider"></div>

                                <div class="approve-level-primary">
                                    Approvers of Level <span class="level-count">{{ approval_required_options[a].text }}</span> (Selected are Primary)
                                </div>

                                <div class="approve-level-inside-container clearfix">
                                    <template v-for="(app,index) in global_approvers[a]">
                                        <template v-if=" selected[a].includes(app.value)">
                                            <b-form-checkbox class="" v-model="primary_selected[a]" :value="app.value" >{{app.text}}</b-form-checkbox>
                                        </template>
                                    </template>
                                </div>

                                <div class="approve-divider"></div>

                                <div class="approve-level-primary">
                                    Minimum Approver Required in this Level
                                </div>

                                <div class="approve-level-primary-minimum">
                                    <b-form-group>
                                        <b-form-select v-model="level_details[a]" :options="generateOptions(a)"></b-form-select>
                                    </b-form-group>
                                </div>


                            </div>

                        </div>
                    </div>

                    <div class="btn-wrapper text-center pt-5" >
                        <b-button class="btn-primary" @click="saveApprovers()" variant="primary">Apply Changes</b-button>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
    export default{

        props: ['pageurl','current_module'],

        data(){

            return {

                approvers_depth : 0,

                approvers_depth_options:[
                    { value: "0", text: "Not Required" },
                    { value: "1", text: "One Level" },
                    { value: "2", text: "Two Level" },
                    { value: "3", text: "Three Level" },
                    { value: "4", text: "Four Level" },
                    { value: "5", text: "Five Level" },
                    { value: "6", text: "Six Level" },
                    { value: "7", text: "Seven Level" },
                    { value: "8", text: "Eight Level" },
                    { value: "9", text: "Nine Level" },
                ],

                approval_required_options:[
                    { value: "0", text: "All" },
                    { value: "1", text: "One" },
                    { value: "2", text: "Two" },
                    { value: "3", text: "Three" },
                    { value: "4", text: "Four" },
                    { value: "5", text: "Five" },
                    { value: "6", text: "Six" },
                    { value: "7", text: "Seven" },
                    { value: "8", text: "Eight" },
                    { value: "9", text: "Nine" },
                ],

                approval_required_options_new:[
                    { value: "0", text: "All" },

                ],

                //current_module : 0,
                selected : [],
                primary_selected : [],
                level_details : [],
                global_approvers : {},

                show_list : false,
                page_title:'',

                //

                require_former_member_consent: true,
                allowed_days_consent: false,
                management_portal_consent: true,

            }
        },
        methods:{
            generateOptions(selected_emps)
            {
                let approval_required_options_generated = [];
                if(this.selected[selected_emps] != undefined)
                {
                    for (let i = 0; i <= this.selected[selected_emps].length; i++)
                    {
                        approval_required_options_generated.push(this.approval_required_options[i]);
                    }
                    return approval_required_options_generated;
                }
                return this.approval_required_options_new;
            },
            findMe(e , l)
            {
                let x = this.selected[l].includes(e);
                this.global_approvers.forEach((value, index) => {

                        if(value != null)
                        {
                            if(index != l)
                            {
                                value[e]['disabled'] = x;
                            }
                        }
                    });
            },
            findMePrimary(e , l)
            {
                let x = this.primary_selected[l].includes(e);
                this.global_approvers.forEach((value, index) => {

                        if(value != null)
                        {
                            if(index != l)
                            {
                                value[e]['disabled'] = x;
                            }
                        }
                    });
            },
            updateApprovers : function()
            {
                let l = this.approvers_depth;

                //alert(this.current_module);
                this.global_approvers = {};

                axios.get(this.$api_url+'/getallapprover?l='+l).then(function(response){

                        this.global_approvers = response.data;
                        this.getApproverSequence();
                    }.bind(this));
            },

            getSettings : function()
            {
                axios.get(this.$api_url+'/approver/settings?module='+this.current_module , {
                    params: {
                    }
                }).then(function(response){

                    this.approvers_depth = response.data.depth;

                    this.level_details = response.data.level_details;

                    this.updateApprovers();

                }.bind(this));
            },
            getApproverSequence : function()
            {
                this.show_list = false;
                axios.get(this.$api_url+'/approver/getsequence?module='+this.current_module , {
                    params: {
                    }
                }).then(function(response){

                    this.selected = response.data.approvers;

                    this.primary_selected = response.data.primary_approvers;

                    let l = this.approvers_depth;
                    for(let i=1 ; i<=l ; i++)
                    {
                        if(this.selected[i] == null)
                            this.selected[i] = [];

                        if(this.primary_selected[i] == null)
                            this.primary_selected[i] = [];

                    }

                    for (var x in this.selected)
                    {
                        if(this.selected[x] != null)
                        {
                            for(var y in this.selected[x])
                            {
                                var z = this.selected[x][y];

                                this.findMe(z , x);
                            }
                        }
                    }



                    for (var x in this.primary_selected)
                    {
                        if(this.primary_selected[x] != null)
                        {
                            for(var y in this.primary_selected[x])
                            {
                                var z = this.primary_selected[x][y];

                            }
                        }
                    }

                    console.log(this.primary_selected);

                    this.show_list = true;

                }.bind(this));
            },

            saveApprovers:function()
            {
                let currentObj = this;
                let formData = new FormData();

                formData.append('sequence', this.selected.join(';'));
                formData.append('primary', this.primary_selected.join(';'));

                formData.append('module', this.current_module);
                formData.append('approvers_depth', this.approvers_depth);
                formData.append('level_details', this.level_details);




                axios.post(this.$api_url+'/approver/savesequence', formData,)
                            .then(function (response)
                            {

                                this.$bvToast.toast('Saved!', {
                                        title: `Success`,
                                        variant: 'success',
                                        solid: true
                                    });


                            }.bind(this))
                            .catch(function (error)
                            {
                                currentObj.serverError(error);
                            });
            }

        },
        created: function(){
            this.getSettings();
            this.page_title = this.$modules[this.current_module];

        },
    }
</script>
